/* unplugin-vue-components disabled */import script from "./gameList.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__